module.exports = __webpack_public_path__ + "media/images/whishlist on-07f22401009de6430049ce711f136489.svg";